import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DonationBanner.css';

const DonationBanner = () => {
  const { t } = useTranslation();
  const [parallaxOffset, setParallaxOffset] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const banner = document.querySelector('.donation-banner');
      if (!banner) return;

      const scrolled = window.scrollY;
      const elementOffset = banner.offsetTop;
      const threshold = elementOffset - window.innerHeight;

      if (scrolled > threshold) {
        setParallaxOffset((scrolled - threshold) * 0.5);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      id="donate-section"
      className="donation-banner"
      style={{ backgroundPosition: `center ${parallaxOffset}px` }}
    >
      <div className="banner-overlay"></div>
      <div className="container">
        <div className="banner-content fade-up">
          <h2>{t('donation_banner_title')}</h2>
          <p>{t('donation_banner_description')}</p>
          <Link to="/donation" className="btn btn-primary pulse">
            {t('donate_now')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default DonationBanner;
